import React from 'react';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { exportTypes } from 'constants/values';

// components
import BaseTrigger from 'triggers/BaseTrigger';
import ExportOptionsMenuPopover from 'common/ExportOptionsMenuPopover';

import { trackAction } from 'util/analytics';

const baseString = 'vra-export-trigger';
const ExportTrigger = ({
  className,
  exportOptionsIsOpen,
  onClickExportTrigger,
  uiLocation,
  shouldFetchJDFields
}) => {

  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const wrapperClassString = classNames({
    [`${baseString}__wrapper`]: true,
    'isSelected': exportOptionsIsOpen
  });

  return (
    <div className={wrapperClassString}>
      <BaseTrigger
        className={classString}
        content={getMessage('button-text__export')}
        dataTestId={baseString}
        handler={() => {
          trackAction(`Clicked on Export Prescription`);
          onClickExportTrigger(shouldFetchJDFields);
        }}
      />
      <ExportOptionsMenuPopover
        exportType={exportTypes.SINGLE}
        uiLocation={uiLocation}
      />
    </div>
  );
};
ExportTrigger.propTypes = {
  className: PropTypes.string,
  exportOptionsIsOpen: PropTypes.bool.isRequired,
  onClickExportTrigger: PropTypes.func.isRequired,
  uiLocation: PropTypes.string.isRequired,
  shouldFetchJDFields: PropTypes.bool,
};
export default ExportTrigger;
